import { render, staticRenderFns } from "./HeaderStartup.vue?vue&type=template&id=08253db9&"
import script from "./HeaderStartup.vue?vue&type=script&lang=js&"
export * from "./HeaderStartup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports